var navbarData = {
    section_1:"Accueil",
    section_2:"A propos",
    section_3:"Comp.",
    section_4:"Projets",
    section_5:"CV",
}

exports.navbarData = navbarData